import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DirectionsWalkIcon(props: IconProps) {
    return <Icon {...props} iconKey={"directions_walk"}/>
}
